"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = require("clsx");
var _uiKit = require("@cian/ui-kit");
var styles = _interopRequireWildcard(require("./styles.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line react/display-name
const Arrow = exports.Arrow = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    direction
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "newbuilding_promo_carousel_arrow",
    ref: ref,
    className: (0, _clsx.clsx)(styles['click_area'], direction < 0 && styles['click_area--left'])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['background']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon_container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon']
  }, direction < 0 ? /*#__PURE__*/React.createElement(_uiKit.IconChevronLeft16, {
    "data-testid": "icon_arrow_left",
    color: 'gray_icons_100'
  }) : /*#__PURE__*/React.createElement(_uiKit.IconChevronRight16, {
    "data-testid": "icon_arrow_right",
    color: 'gray_icons_100'
  })))));
});